import { render, staticRenderFns } from "./BootMenu.vue?vue&type=template&id=3066fd61&scoped=true&"
import script from "./BootMenu.vue?vue&type=script&lang=ts&"
export * from "./BootMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BootMenu.vue?vue&type=style&index=0&id=3066fd61&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3066fd61",
  null
  
)

export default component.exports